export default "__VITE_ASSET__DFp5L1qD__"